<template>
  <div class="answer-section">
    <div class="container">
      <div class="download-list">
        <div class="download-item" v-for="(item,index) in list" :key="index" @click="downlaod(item)">
          <div class="u-flex u-gap-6">
            <img src="../../assets/image/file.png" alt="">
            <div class="download-file">
              <span class="file-name">{{ item.title }}</span>
              <span class="file-size">{{item.file_size}}</span>
            </div>
          </div>
          <button class="download-btn"><i class="el-icon-download"></i> 下载</button>
        </div>
      </div>
      <!-- 分页 -->
      <div class="u-flex u-row-center u-m-t-60" v-if="list.length !== 0">
        <el-pagination
          layout="prev, pager, next"
          background
          :total="records"
          :current-page.sync="page"
          :page-size.sync="limit"
          @current-change="getlist"
          @size-change="getlist"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { evaluationMaterials } from '@/api/index'
import { httphosts } from '@/utils/global'

export default {
  data() {
    return {
       // 可以在这里添加数据
      list: [],
      records: 0,
      page: 1,
      limit: 12,
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist() {
     evaluationMaterials({
        page: this.page,
        limit: this.limit
      }).then(res => {
        if (res.code === 1) {
          this.list = res.data.list
          this.records = res.data.total
        }
      })
    },
    downlaod(item) {
      // 直接下载文件到本地
      const link = document.createElement('a')
      link.href = httphosts + item.file_path
      link.download = item.title
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  }
}
</script>

<style scoped>
.answer-section{
  padding: 60px 0;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.download-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.download-item {
  position: relative;
  padding: 30px;
  background: #FFFFFF;
  box-shadow: 0px 3px 8px 1px rgba(60,97,135,0.05);
  border-radius: 8px 8px 8px 8px;
  transition: all 0.3s ease;
}

.download-item:hover {
  transform: translateY(-3px);
  /* box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1); */
}

.download-file {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.file-name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  font-size: 12px;
  color: #999;
}

.download-btn {
  position: absolute;
  bottom: 12px;
  right: 12px;
  padding: 6px 12px;
  background-color: transparent;
  color: #0066cc;
  border: none;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.download-btn:hover {
  /* background-color: #0052a3; */
  color: #F66F00;
}
</style>